"use client"

import { Skeleton } from "antd"

interface FormSkeletonProps {
  mainSections?: number
  sidebarCards?: number
}

const SectionSkeleton = ({ rows = 4 }: { rows?: number }) => (
  <div
    style={{
      background: "var(--admin-surface)",
      border: "1px solid var(--admin-border)",
      borderRadius: 8,
      padding: 20,
      marginBottom: 16,
    }}
  >
    <Skeleton active title={{ width: "30%" }} paragraph={{ rows, width: ["100%", "80%", "100%", "60%"] }} />
  </div>
)

const SidebarCardSkeleton = () => (
  <div
    style={{
      background: "var(--admin-surface)",
      border: "1px solid var(--admin-border)",
      borderRadius: 8,
      padding: 14,
      marginBottom: 12,
    }}
  >
    <Skeleton active title={{ width: "50%" }} paragraph={{ rows: 2, width: ["100%", "70%"] }} />
  </div>
)

export function FormSkeleton({ mainSections = 2, sidebarCards = 3 }: FormSkeletonProps) {
  return (
    <div
      aria-busy
      aria-live="polite"
      style={{
        maxWidth: 1060,
        marginLeft: "auto",
        marginRight: "auto",
        paddingLeft: 16,
        paddingRight: 16,
      }}
    >
      {/* Breadcrumb row */}
      <div style={{ marginBottom: 8 }}>
        <Skeleton active title={{ width: 180 }} paragraph={false} style={{ lineHeight: 1 }} />
      </div>
      {/* Title row */}
      <div style={{ marginBottom: 16 }}>
        <Skeleton active title={{ width: 260 }} paragraph={false} />
      </div>
      {/* Grid — mirrors FormShell: 2-pane when sidebar present, single-column otherwise */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: sidebarCards > 0 ? "minmax(0, 680px) 300px" : "1fr",
          gap: sidebarCards > 0 ? 32 : 0,
          alignItems: "start",
        }}
      >
        <div style={{ minWidth: 0 }}>
          {Array.from({ length: mainSections }).map((_, i) => (
            <SectionSkeleton key={i} rows={i === 0 ? 3 : 6} />
          ))}
        </div>
        {sidebarCards > 0 && (
          <div style={{ position: "sticky", top: 88 }}>
            {Array.from({ length: sidebarCards }).map((_, i) => (
              <SidebarCardSkeleton key={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default FormSkeleton
